import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from 'Components/UI/BehavioralFormElement/LabelDecorator/Floating';
import NumberInput from 'Components/UI/BehavioralFormElement/NormalizedInput/Number';
import {
  numberOrBlank,
  singleOrArray,
  stringOrFunction,
} from 'Helpers/PropTypes';

const NumberInputAlias = ({
  className,
  label,
  test,
  placeholder,
  ...props
}) => (
  <FloatingLabel className={`Number ${className}`} label={label}>
    <NumberInput test={test} placeholder={placeholder} {...props} />
  </FloatingLabel>
);

NumberInputAlias.propTypes = {
  className: PropTypes.string,
  decimalScale: PropTypes.number,
  format: stringOrFunction,
  label: PropTypes.string,
  mask: singleOrArray(PropTypes.string),
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  value: numberOrBlank,
  onChange: PropTypes.func.isRequired,
  test: PropTypes.string,
};

NumberInputAlias.defaultProps = {
  className: '',
  decimalScale: undefined,
  format: undefined,
  label: '',
  mask: ' ',
  max: Number.POSITIVE_INFINITY,
  min: Number.NEGATIVE_INFINITY,
  placeholder: '',
  prefix: undefined,
  suffix: undefined,
  value: '',
  test: '',
};

export default NumberInputAlias;
